import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function DimensionsMissing(props) {
    return (
        <span className="statusbar__missing-status">
            <span className="statusbar__add-information" onClick={props.onClick}>
                <Translation translationKey="catalog-missing-status-missing-dimensions-clickable" />
            </span>
        </span>
    );
}

DimensionsMissing.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default DimensionsMissing;
